import * as z from "zod";

export const connectTeamTo3pl = {
  name: "connectTeamTo3pl" as const,
  input: z.object({
    fulfillmentServiceTeamId: z.string(),
    teamToFulfillFor: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
